import React, { useContext, useState } from "react";
import moji from "moji";
import GridItemText from "./GridItemText";
import {
  Alert,
  Box,
  Button,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import { RadioButtonChecked } from "@mui/icons-material";
import module from "./FormSelfInformation.module.css";
import BankInfoForm from "./BankInfoForm";
import BranchForm from "./BranchForm";
import { RewardSettingContext } from "../../../contexts/RewardSettingContext";
import VALIDATE_REWARD_SETTING, { isIncludedFullWidthKana } from "../../../util/validateRewardSetting";
import { Link } from "react-router-dom";

const FormBankData = () => {
  const { bank } = useContext(RewardSettingContext);
  const [accountPersonNameError, setAccountPersonNameError] = useState(null);
  const [accountNumError, setAccountNumError] = useState(null);
  const [convertedAccountPersonName, setConvertedAccountPersonName] = useState("");

  const handleAccountPersonName = (e) => {
    const value = e.target.value;
    if (accountPersonNameError) {
      setAccountPersonNameError(null);
    }
    const validate = VALIDATE_REWARD_SETTING.ACCOUNT_PERSON_NAME(value);
    if (validate) {
      setAccountPersonNameError(validate);
    }

    if (!value) {
      setConvertedAccountPersonName("");
    } else if (isIncludedFullWidthKana(value)) {
      const converted = moji(value).convert("ZK", "HK").toString();
      setConvertedAccountPersonName(converted);

    }
  }

  const handleAccountNum = (e) => {
    const value = e.target.value;
    if (accountNumError) {
      setAccountNumError(null);
    }
    const validate = VALIDATE_REWARD_SETTING.ACCOUNT_NUM(value);
    if (validate) {
      setAccountNumError(validate);
    }
  }

  const handleClickConvert = () => {
    const ele = document.getElementById("account_person_name");
    ele.value = convertedAccountPersonName;
    setConvertedAccountPersonName("");
    const validate = VALIDATE_REWARD_SETTING.ACCOUNT_PERSON_NAME(convertedAccountPersonName);
    if (validate) {
      setAccountPersonNameError(validate);
    } else {
      setAccountPersonNameError(null);
    }
  }

  return (
    <>
      <BankInfoForm />
      <BranchForm />
      <FormControl
        sx={{ textAlign: "left", width: "100%", marginBottom: "16px" }}
        required
      >
        <FormLabel
          id="account_category"
          sx={{
            color: "black",
            fontSize: "0.9rem",
          }}
          className={module.radioLabel}
        >
          口座区分
        </FormLabel>
        <RadioGroup
          aria-labelledby="account_category"
          name="account_category"
          defaultValue={bank.saved ? bank.saved.account_category : "normal"}
        >
          <FormControlLabel
            value={"normal"}
            control={
              <Radio checkedIcon={<RadioButtonChecked color="black" />} />
            }
            label="普通"
          />
          <FormControlLabel
            value={"checking"}
            control={
              <Radio checkedIcon={<RadioButtonChecked color="black" />} />
            }
            label="当座"
          />
        </RadioGroup>
      </FormControl>
      <GridItemText
        label="口座番号"
        placeholder={"例：0000000"}
        name={"account_num"}
        defaultValue={bank.saved && bank.saved.account_num}
        onChange={handleAccountNum}
        error={accountNumError}
        helperText={"口座番号が6桁の場合は、先頭に0を入力してください。"}
      />
      <GridItemText
        label="口座名義人"
        placeholder={"例：ﾔﾏﾀﾞﾀﾛｳ"}
        name={"account_person_name"}
        defaultValue={bank.saved && bank.saved.account_person_name}
        onChange={handleAccountPersonName}
        error={accountPersonNameError}
        helperText={"半角カナで入力してください。姓名の間に空白は不要です。"}
      />
      {convertedAccountPersonName && (
        <>
          <Grid container>
            <Grid item xs={7}>
              <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "50px",
                border: "1px solid #ccc",
                borderRadius: "4px",
              }}>
                {convertedAccountPersonName}
              </Box>
            </Grid>

            <Grid item xs={5}>
              <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100%",
              }}>
                <Button
                  variant="outlined"
                  sx={{
                    marginBottom: "16px",
                  }}
                  onClick={handleClickConvert}
                >変換が正しいことを確認</Button>
              </Box>
            </Grid>
          </Grid>
        </>
      )
      }
    </>
  );
};

export default FormBankData;
